import {
    Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input, Output, EventEmitter,
    ComponentFactoryResolver, ViewContainerRef, OnChanges, SimpleChanges
} from "@angular/core";
import { ProductPopupComponent } from './product-popup';
import { DosageAppPopupComponent } from './dosage-app-popup';
import { ApothekenReservierungComponent } from './apotheken-reservierung';
import { SharedService } from '../../shared';
import { Perscriptions, CannabisQuestion, CannabisOption, THC_CBD_Group, SharedComponent, PartnerNamesEnum } from '../shared';
import { etwasAnderes } from '../data';

declare var jsPanel: any;

@Component({
    selector: 'app-product-dosage',
    templateUrl: "./product-dosage.component.html",
    styleUrls: ["./product-dosage.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ProductDosageComponent implements OnInit, OnChanges {
    @Input() partnerName: string = "";

    @Input() perscriptions: Perscriptions[] = [];
    @Input() productOneOption: CannabisOption;
    @Input() secTwoQuestTwoOption: CannabisOption;
    @Input() secTwoQuestOneGroup: THC_CBD_Group;
    @Output() updatedData = new EventEmitter<any>();
    @Output() updateSecTwoQuestTwoOption = new EventEmitter<any>();

    PartnerNamesEnum = PartnerNamesEnum;

    ProductTableSortingColumn: string = "";

    productTypeList: string[] = [];
    fetchedBatchData: any = [];
    batchData: any[] = [];
    productDataList: any[] = [];
    strainList: string[] = [];

    maxTHC: number = 0;
    maxCBD: number = 0;

    jsPanelPopup: any;

    usedForButtons: CannabisOption[] = [
        { Label: "Tag" },
        { Label: "Nacht" },
        { Label: etwasAnderes }
    ];

    get panelWidth() {
        return Math.min(1400, window.innerWidth * 0.9);
    }

    get panelHeight() {
        return Math.min(1100, window.innerHeight * 0.9);
    }

    get jsPanelContentHeight() {
        return document.getElementsByClassName("jsPanel-content")[0].clientHeight;
    }

    get GroupTitle() {
        return (this.secTwoQuestOneGroup && this.secTwoQuestOneGroup.Title) ? this.secTwoQuestOneGroup.Title : "";
    }

    get isTHCCBDSelected() {
        return this.GroupTitle && this.GroupTitle.length > 0;
    }

    get IsTHC() {
        return this.GroupTitle && this.GroupTitle.indexOf("THC") > -1;
    }

    get IsDronabinol() {
        return this.GroupTitle && this.GroupTitle.indexOf("CBD") === -1;
    }

    get IsTHCAndCBD() {
        return this.GroupTitle && this.GroupTitle.indexOf("THC") > -1 && this.GroupTitle.indexOf("CBD") > -1;
    }

    get isPartnerPage() {
        return this.partnerName && this.partnerName.length;
    }

    constructor(private cd: ChangeDetectorRef,
        private vcr: ViewContainerRef,
        private resolver: ComponentFactoryResolver,
        private sharedService: SharedService) {
    }

    ngOnInit(): void {
        if (this.perscriptions.length === 0) {
            this.addNewPersc();
        }
        this.getPartnerConfig();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.perscriptions.length === 0) {
            this.addNewPersc();
        }

        for (const propName in changes) {
            if (changes.hasOwnProperty(propName)) {
                let change = changes[propName];
                switch (propName) {
                    case 'secTwoQuestTwoOption':
                        if (change.previousValue !== change.currentValue) {
                            this.setProductTypeList();
                            this.fnBindProductDataList();
                        }
                        break;
                }
            }
        }
    }

    addNewPersc() {
        this.perscriptions.push({
            product: '',
            dosage: '',
            usedFor: [],
            value: ''
        })
    }

    removePersc(index) {
        this.perscriptions.splice(index, 1);
        if (this.perscriptions.length === 0) {
            this.addNewPersc();
        }
        this.updatePersc();
    }



    activeSelectedOption(pers: Perscriptions, option: CannabisOption) {
        return pers.usedFor.findIndex(a => a.Label === option.Label) > -1;
    }

    hasFreeTextActve(pers: Perscriptions) {
        return pers.usedFor.findIndex(a => a.Label.indexOf(etwasAnderes) > -1) > -1;
    }

    selectOption(pers: Perscriptions, option: CannabisOption) {
        let index = pers.usedFor.findIndex(a => a.Label === option.Label);
        if (index == -1) {
            pers.usedFor.push(option)
        } else {
            pers.usedFor.splice(index, 1);
        }
        this.updatePersc();
    }

    onChoosePers(product: string, pers: Perscriptions) {
        pers.product = product;
        this.updatePersc();
    }

    updatePersc() {
        this.updatedData.emit(this.perscriptions);
        this.cd.detectChanges();
    }

    setProductTypeList() {
        this.productTypeList = [];
        if (this.partnerName !== PartnerNamesEnum.ALTHEA) {
            this.productTypeList.push("Blüten");
        }

        if (!this.partnerName || this.partnerName == PartnerNamesEnum.AVEXTRA) {
            if (this.IsTHCAndCBD) {
                this.productTypeList.push("Cannabisextrakt Kapseln");
            }
        }
        this.productTypeList.push("Extrakt");
        switch (this.partnerName) {
            case PartnerNamesEnum.ADREX:
            case PartnerNamesEnum.AVEXTRA:
            case PartnerNamesEnum.ALTHEA:
            case PartnerNamesEnum.BETAHEALTH:
            case PartnerNamesEnum.SWISS:
            case PartnerNamesEnum.FOUR_20_PHARMA:
                break;
            default: {
                this.productTypeList.push("Fertigarzneimittel");
            }
        }
        switch (this.partnerName) {
            case PartnerNamesEnum.AVEXTRA:
                if (this.IsDronabinol || !this.isTHCCBDSelected) {
                    this.productTypeList.push("Dronabinol");
                }
                break;
            case PartnerNamesEnum.ALTHEA:
                break;
            case PartnerNamesEnum.BETAHEALTH:
            case PartnerNamesEnum.FOUR_20_PHARMA:
                break;
            default: {
                if (this.IsDronabinol || !this.isTHCCBDSelected) {
                    this.productTypeList.push("Dronabinol");
                }
                if (!this.IsTHC || !this.isTHCCBDSelected) {
                    this.productTypeList.push("Cannabidiol");
                }
            }
        }
    }

    getTHCAndCBD(batch) {
        var thc = 0;
        var thcUnit = "";
        var thcEquality = "";
        var cbd = 0;
        var cbdUnit = "";
        var cbdEquality = "";
        if (batch.Cannabinoids != null && batch.Cannabinoids.length > 0) {
            try {
                var thcModel = batch.Cannabinoids.find(a => a.name == "THC");
                var cbdModel = batch.Cannabinoids.find(a => a.name == "CBD");
                if (thcModel != null) {
                    thc = thcModel.value || 0;
                    thcUnit = thcModel.unit || "";
                    thcEquality = thcModel.equality || "";
                }
                if (cbdModel != null) {
                    cbd = cbdModel.value || 0;
                    cbdUnit = cbdModel.unit || "";
                    cbdEquality = cbdModel.equality || "";
                }
            }
            catch (ex) {
            }
        }
        return {
            THC: thc,
            THC_UNIT: thcUnit,
            THC_Equality: thcEquality,
            CBD: cbd,
            CBD_UNIT: cbdUnit,
            CBD_Equality: cbdEquality
        };
    }

    getPartnerConfig() {
        let Pharmacy = [];
        let ProducerNameRegExp = [];
        let ProductsNameRegExp = [];
        this.sharedService.getPartnerConfig().subscribe(res => {
            if (res) {
                let partnerObj = res[this.partnerName];
                if (partnerObj) {
                    Pharmacy = partnerObj["Pharmacy"] || [];
                    ProducerNameRegExp = partnerObj["ProducerNameRegExp"] || [];
                    ProductsNameRegExp = partnerObj["ProductsNameRegExp"] || [];
                    this.ProductTableSortingColumn = partnerObj["ProductTableSortingColumn"] || "";
                }
            }
            this.getAllUniqueBatches({ Pharmacy, ProducerNameRegExp, ProductsNameRegExp });
        }, err => {
            this.getAllUniqueBatches({ Pharmacy, ProducerNameRegExp, ProductsNameRegExp });
        })
    }

    getAllUniqueBatches(payload) {
        this.batchData = [];
        this.sharedService.getAllUniqueBatches(payload).subscribe(res => {
            this.fetchedBatchData = [...res];
            this.fnBindBatchData(this.fetchedBatchData);
            this.setProductTypeList();
            this.fnBindProductDataList();
        })
    }

    fnBindBatchData(res) {
        let component = this;
        let maxTHC = 0;
        let maxCBD = 0;

        for (var i = 0; i < res.length; i++) {
            var record = res[i];
            var THC = 0;
            var THC_UNIT = "";
            var THC_Equality = "";
            var CBD = 0;
            var CBD_UNIT = "";
            var CBD_Equality = "";

            var indStrain = this.strainList.findIndex(a => a.trim().toUpperCase() === record.Strain.trim().toUpperCase());
            if (record.Strain && indStrain === -1) {
                this.strainList.push(record.Strain.trim());
            }

            if (record.SimilarBatches.length) {
                record.SimilarBatches.forEach(item => {
                    var THC_CBD = component.getTHCAndCBD(item);
                    item["Level"] = 2;
                    item["THC_UNIT"] = THC_CBD.THC_UNIT;
                    item["THC_Equality"] = THC_CBD.THC_Equality;
                    item["CBD_UNIT"] = THC_CBD.CBD_UNIT;
                    item["CBD_Equality"] = THC_CBD.CBD_Equality;

                    item["THC"] = THC_CBD.THC;
                    item["CBD"] = THC_CBD.CBD;
                    THC += THC_CBD.THC;
                    CBD += THC_CBD.CBD;

                    var indStrainSim = this.strainList.findIndex(a => a.trim().toUpperCase() === item.Strain.trim().toUpperCase());
                    if (item.Strain && indStrainSim === -1) {
                        this.strainList.push(item.Strain.trim());
                    }
                })
                var divide = record.SimilarBatches.length;
                THC = THC > 0 ? (THC / divide) : 0;
                CBD = CBD > 0 ? (CBD / divide) : 0;

                var THC_CBD = component.getTHCAndCBD(record);
                THC_UNIT = THC_CBD.THC_UNIT;
                THC_Equality = THC_CBD.THC_Equality;
                CBD_UNIT = THC_CBD.CBD_UNIT;
                CBD_Equality = THC_CBD.CBD_Equality;

                record["_attributes"] = { expanded: false };
                record["_children"] = record.SimilarBatches;
            } else {
                var THC_CBD = component.getTHCAndCBD(record);
                THC_UNIT = THC_CBD.THC_UNIT;
                THC_Equality = THC_CBD.THC_Equality;
                CBD_UNIT = THC_CBD.CBD_UNIT;
                CBD_Equality = THC_CBD.CBD_Equality;

                THC = THC_CBD.THC;
                CBD = THC_CBD.CBD;
            }
            record["Level"] = 1;
            record["THC_UNIT"] = THC_UNIT;
            record["THC_Equality"] = THC_Equality;
            record["CBD_UNIT"] = CBD_UNIT;
            record["CBD_Equality"] = CBD_Equality;
            record["THC"] = Math.round(THC) != THC ? THC.toFixed(2) : THC;
            record["CBD"] = Math.round(CBD) != CBD ? CBD.toFixed(2) : CBD;

            if (parseFloat(record.THC) > maxTHC) {
                maxTHC = parseFloat(record.THC);
            }
            if (parseFloat(record.CBD) > maxCBD) {
                maxCBD = parseFloat(record.CBD);
            }

            this.batchData.push(record);
        }

        maxTHC = Math.ceil(maxTHC) + 1;
        maxCBD = Math.ceil(maxCBD) + 1;
        this.maxTHC = maxTHC;
        this.maxCBD = maxCBD;

        this.strainList.sort();
    }

    fnBindProductDataList() {
        let component = this;
        this.productDataList = [];
        this.batchData.forEach(batch => {
            if (batch.SimilarBatches.length) {
                batch.SimilarBatches.forEach(item => {
                    let ProducerName = item.ProducerName.trim();
                    let ProductName = item.ProductName.trim();
                    let DisplayName = `${ProducerName}, ${ProductName}`;
                    if (component.productTypeList.indexOf(item.ProductType) > -1 && component.productDataList.findIndex(a => a.DisplayName === DisplayName) === -1) {
                        component.productDataList.push({ ProducerName, ProductName, DisplayName });
                    }
                })
            }
            let ProducerName = batch.ProducerName.trim();
            let ProductName = batch.ProductName.trim();
            let DisplayName = `${ProducerName}, ${ProductName}`;
            if (component.productTypeList.indexOf(batch.ProductType) > -1 && component.productDataList.findIndex(a => a.DisplayName === DisplayName) === -1) {
                component.productDataList.push({ ProducerName, ProductName, DisplayName });
            }
        })
        this.productDataList.sort(this.compareDisplayName);
    }

    compareDisplayName(a, b) {
        if (a.DisplayName < b.DisplayName) {
            return -1;
        }
        if (a.DisplayName > b.DisplayName) {
            return 1;
        }
        return 0;
    }

    getSelectedProductDetail(product) {
        let batch = this.batchData.find(a => (`${a.ProducerName.trim()}, ${a.ProductName.trim()}`).toLowerCase() == product.toLowerCase().trim());
        return batch;
    }

    updateProductPersValue(pers: Perscriptions, selectedRow) {
        let productName = selectedRow.ProductName;
        let batch = this.batchData.find(a => a.ProductName.toLowerCase().trim() == productName.toLowerCase().trim());
        if (batch) {
            pers.product = `${batch.ProducerName.trim()}, ${batch.ProductName.trim()}`;
        }
        this.updatedData.emit(this.perscriptions);
        this.cd.detectChanges();
    }


    openBatchSearch(pers: Perscriptions) {
        if (!this.batchData.length) {
            alert("There are no products available.")
            return;
        }
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(ProductPopupComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.partnerName = this.partnerName;
        componentRef.instance.ProductTableSortingColumn = this.ProductTableSortingColumn;
        componentRef.instance.batchData = this.batchData;
        componentRef.instance.strainList = this.strainList;
        componentRef.instance.maxTHC = this.maxTHC;
        componentRef.instance.maxCBD = this.maxCBD;
        componentRef.instance.productValue = pers.product;
        componentRef.instance.productOneOption = this.productOneOption;
        componentRef.instance.secTwoQuestTwoOption = this.secTwoQuestTwoOption;
        componentRef.instance.secTwoQuestOneGroup = { ...this.secTwoQuestOneGroup };
        componentRef.instance.onSelectBatch.subscribe(product => {
            component.updateProductPersValue(pers, product);
            this.jsPanelPopup.close();
        });
        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Cannabisprodukt Übersicht',
            onwindowresize: true,
            onstatuschange: (panel, status) => {
                componentRef.instance.fnUpdatePopupContent(true);
            },
            resizeit: {
                resize: (panel, paneldata, event) => {
                    componentRef.instance.fnUpdatePopupContent(true);
                }
            },
            content: element,
            callback: function (panel) {
                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                if (componentRef.instance.productGrid) {
                                    let selectedRows = componentRef.instance.productGrid.getCheckedRows();
                                    if (selectedRows.length) {
                                        let selectedRow = selectedRows[0];
                                        component.updateProductPersValue(pers, selectedRow);
                                    }
                                    panel.close();
                                }
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }

    openDosageApp(pers: Perscriptions) {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(DosageAppPopupComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.partnerName = this.partnerName;
        componentRef.instance.selectedProductName = pers.product;
        componentRef.instance.selectedProduct = this.getSelectedProductDetail(pers.product);
        componentRef.instance.secTwoQuestTwoOption = this.secTwoQuestTwoOption;
        componentRef.instance.secTwoQuestOneGroup = { ...this.secTwoQuestOneGroup };
        componentRef.instance.updateSecTwoQuestTwoOption.subscribe(option => {
            this.updateSecTwoQuestTwoOption.emit(option);
        })
        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Dosierung und Menge berechnen',
            onwindowresize: true,
            content: element,
            callback: function (panel) {

                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                const dosage = componentRef.instance.dosageTextareaValue;
                                pers.dosage = `${dosage}`;
                                component.updatedData.emit(component.perscriptions);
                                component.cd.detectChanges();
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }


    openApothekenReservierungPopup() {
        let panels = jsPanel.getPanels();
        panels.forEach(panel => {
            panel.close();
        })

        let component = this;
        // Code for get html element from component
        const factory = this.resolver.resolveComponentFactory(ApothekenReservierungComponent);
        const componentRef = this.vcr.createComponent(factory);
        componentRef.instance.partnerName = this.partnerName;
        const element = componentRef.location.nativeElement;

        this.jsPanelPopup = jsPanel.create({
            theme: 'dark',
            footerToolbar: [
                '<button type="button" class="btn btn-sm btn-danger mr-2" data-type="close">Stornieren</button>',
                '<button type="button" class="btn btn-sm btn-success" data-type="ok">Ok</button>'
            ],
            panelSize: {
                width: () => { return component.panelWidth; },
                height: () => { return component.panelHeight; }
            },
            animateIn: 'jsPanelFadeIn',
            headerTitle: 'Apotheken Reservierung',
            onwindowresize: true,
            content: element,
            callback: function (panel) {

                // Footer button Functionality
                for (const btn of panel.footer.querySelectorAll('button')) {
                    btn.addEventListener('click', (e) => {
                        var dataType = e.target.getAttribute("data-type");
                        switch (dataType) {
                            case "ok":
                                panel.close();
                                break;
                            default:
                                panel.close();
                                break;
                        }
                    });
                }
            }
        });
        this.jsPanelPopup = this.sharedService.setJsPanelProperty(this.jsPanelPopup, this.partnerName);
    }
}
